import get from 'lodash/get';
import isNaN from 'lodash/isNaN';

export default (el) => {
  const borderTopWidthStyle = get(el, ['style', 'borderTopWidth']);
  const borderTopWidth = parseInt(borderTopWidthStyle, 10);

  return isNaN(borderTopWidth) ? 0 : borderTopWidth;
};
